<div class="gauge-container {{ mode }}">
    <div class="gauge-value-wrapper" *ngIf="shouldShowScore" [class.overlap]="shouldShowCoverageRange">
        <span class="label">{{ 'confidenceGauge.score' | translate }}</span>
        <span class="value">
            <span>{{ value }}</span>
            <sup (click)="openScoreInfoDialog($event)"><a href="#">&#63;</a></sup>
        </span>
    </div>
    <div class="gauge-labels" *ngIf="shouldShowConfidenceLabels">
        <span class="gauge-label low">
            <span>{{ 'confidenceGauge.confidence.low' | translate }}</span>
            <span *ngIf="!shouldShowCoverageRange && !shouldShowMinMaxValues">{{ min }}-{{ averageConfidenceThreshold - 1 }}</span>
        </span>
        <span class="gauge-label average" *ngIf="!shouldShowCoverageRange && !shouldShowMinMaxValues">
            <span>{{ 'confidenceGauge.confidence.average' | translate }}</span>
            <span *ngIf="!shouldShowCoverageRange && !shouldShowMinMaxValues">{{ averageConfidenceThreshold }}-{{ highConfidenceThreshold - 1 }}</span>
        </span>
        <span class="gauge-label high">
            <span>{{ 'confidenceGauge.confidence.high' | translate }}</span>
            <span *ngIf="!shouldShowCoverageRange && !shouldShowMinMaxValues">{{ highConfidenceThreshold }}-{{ max }}</span>
        </span>
    </div>
    <div class="gauge-wrapper">
        <div [style.--gauge-width]="progressWidth$ | async"
             class="gauge-progress"></div>
    </div>
    <div class="gauge-values" *ngIf="shouldShowMinMaxValues">
        <span class="low">{{ min }}</span>
        <span class="high">{{ max }}</span>
    </div>
    <div class="gauge-ranges"  *ngIf="shouldShowCoverageRange">
        <div [style.width]="getRangeWidth(min, coverageThreshold)"
             class="range no-coverage">
            <span class="label min">{{ min }}</span>
            <span class="label">
                @if (value > coverageThreshold) {
                    {{ 'confidenceGauge.coverage.noCoverage' | translate }}
                }
            </span>
            <span class="label max">{{ coverageThreshold }}</span>
        </div>
        <div [style.width]="getRangeWidth(coverageThreshold + 1, max)"
             class="range with-coverage">
            <span class="label min">{{  coverageThreshold + 1 }}</span>
            <span class="label">
                @if (value > coverageThreshold) {
                    {{ 'confidenceGauge.coverage.withCoverage' | translate }}
                }
            </span>
            <span class="label max">{{ max }}</span>
        </div>
    </div>
</div>
